<template>
  <div class="app-wrapper">
    <div class="header">
      <div class="info">
        <div class="company_name">
          <b v-text="infos.company_name"></b>
        </div>
        <div class="flex jc-sb">
          <div class="flex memberid">
            <van-icon name="manager" />
            <span v-text="infos.username"></span>
          </div>
          <span class="logout" @click="logout">退出</span>
        </div>
      </div>
    </div>
    <router-view class="views" />
    <div class="menu">
      <router-link to="/" class="home"><van-icon name="wap-home" />首页</router-link>
      <van-button class="signup" type="info" icon="plus" @click="$router.push('/signup')">开始报名</van-button>
      <router-link to="/notice" class="notice"><van-icon name="chat" />消息</router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Layout",
  methods: {
    logout() {
      this.$store.dispatch('user/logout').then(() => {
        this.$router.push('/login')
      })
    }
  },
  computed: {
    ...mapGetters(['infos']),
  },
  created() {

  }
};
</script>

<style lang="less" scoped>
@main-color: #1989fa;

.app-wrapper {
  position: absolute;
  z-index: 1;
  width: 100%;

  .header {
    position: relative;
    z-index: 0;
    padding: 10%;
    min-height: 50vw;
    color: #fff;
    box-sizing: border-box;
    background: @main-color url("/static/images/header_bg.png") 90% bottom / 40% no-repeat;

    .company_name {
      font-size: 1.2rem;
      margin-bottom: 5%;
    }

    .memberid,
    .logout {
      font-size: 0.9rem;
    }
  }

  .views {
    position: relative;
    z-index: 1;
    width: 100%;
    padding-bottom: 20vw;
  }

  .menu {
    position: fixed;
    z-index: 1;
    display: flex;
    justify-content: space-between;
    left: 0;
    right: 0;
    bottom: 0;

    border-top: 1px solid @main-color;
    background: #ffffff;

    .signup {
      position: absolute;
      width: 38%;
      top: -50%;
      left: 50%;
      padding: 5% 0;
      background: @main-color;
      border-radius: 10px;
      font-size: 1rem;
      transform: translateX(-50%);
    }

    a {
      box-sizing: border-box;
      display: inline-block;
      height: 12vw;
      line-height: 12vw;
      font-size: 1rem;
      width: 35%;
      text-align: center;
      color: @main-color;
    }

    .van-icon {
      margin-right: 2%;
    }
  }

}
</style>
